import React from 'react';
import * as Sentry from '@sentry/nextjs';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface ErrorBoundaryProps {
  errorBoundaryKey?: string;
}

function ErrorBoundary({
  children,
  ...props
}: React.PropsWithChildren<ErrorBoundaryProps>) {
  const { errorBoundaryKey } = props;
  const onErrorHandle = (error: Error, info: { componentStack: string }) => {
    Sentry.captureException(error, {});
    if (errorBoundaryKey) {
      console.info(`Error Boundary: `, errorBoundaryKey);
    }
    console.info(`Error Stack: `, info.componentStack);
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={() => <div>Something went wrong</div>}
      onError={onErrorHandle}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
